import target from "./targets/target";

/**
 * Help method which returns subdomain.
 * 
 * @param {*} domain 
 * @returns 
 */
const getSubdomain = (domain) => {
    const hostname = window.location.hostname;
    // domain should correspond to the current hostname
    if(hostname.endsWith(domain)) {
        return hostname.substring(0, hostname.length - domain.length - 1);
    }
    console.error("Domain does not match the hostname");
    return undefined;
}

/**
 * Help method which calculates API url.
 * 
 * @param {*} rootConfig 
 * @returns 
 */
const getApiUrl  = (rootConfig) => {
    const subdomain = rootConfig.subdomain ? rootConfig.subdomain + "." : "";
    const port = rootConfig.apiPort ? ":" + rootConfig.apiPort : "";

    return `${rootConfig.apiProtocol}://${subdomain}${rootConfig.apiDomain}${port}/${rootConfig.apiPath}`;
}

/**
 * Help method which calculates application URL.
 * 
 * @param {*} subdomain 
 * @returns 
 */
const getUrl = (subdomain) => {
    const portSuffix = APP.port ? ":" + APP.port : "";
    return `${APP.protocol}://${subdomain}.${APP.domain}${portSuffix}`;
}

/**
 * Help method which creates root config.
 */
const getRootConfig = () => {
    const domain = process.env.REACT_APP_DOMAIN;
    const subdomain = getSubdomain(domain);

    const rootConfig = {
        target: process.env.REACT_APP_TARGET,
        domain: domain,
        subdomain: subdomain,
        protocol: process.env.REACT_APP_PROTOCOL,
        port: process.env.REACT_APP_PORT,
        apiDomain: process.env.REACT_APP_API_DOMAIN,
        apiPort: process.env.REACT_APP_API_PORT,
        apiPath: process.env.REACT_APP_API_PATH,
        apiProtocol: process.env.REACT_APP_API_PROTOCOL,
        apiUrl: "",
        appUrl: getUrl
    };

    // set apiUrl
    rootConfig.apiUrl = getApiUrl(rootConfig);

    return rootConfig;
}

/**
 * Help method which creates target config.
 */
const getTargetConfig = (rootConfig) => {
    return target(rootConfig);
}

/**
 * Public method which regenerates APP configuration.
 * 
 * @returns APP
 */
export const getApp = () => {
    const rootConfig = getRootConfig();
    const targetConfig = getTargetConfig(rootConfig);

    // merge configs
    const config = {
        ...rootConfig,
        // target config overrides root config
        ...targetConfig
    }
    
    //console.log("APP configuration", config);

    return config;
}

/**
 * Public APP configuration.
 */
const APP = getApp();
export default APP;